function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}

import PropTypes from "prop-types";

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];

  return arr2;
}

import chroma from 'chroma-js';
import React from 'react';
import { EuiText, EuiFlexGrid, EuiBadge, EuiCopy, EuiFlexItem, EuiPanel, EuiHorizontalRule } from '../../../../../src'; // @ts-ignore Importing from JS

import { useJsonVars } from '../_json/_get_json_vars';
export var coreColors = ['euiColorPrimary', 'euiColorAccent', 'euiColorSuccess', 'euiColorWarning', 'euiColorDanger'];
export var coreTextVariants = ['euiColorPrimaryText', 'euiColorAccentText', 'euiColorSuccessText', 'euiColorWarningText', 'euiColorDangerText'];
export var grayColors = ['euiColorEmptyShade', 'euiColorLightestShade', 'euiColorLightShade', 'euiColorMediumShade', 'euiColorDarkShade', 'euiColorDarkestShade', 'euiColorFullShade'];
export var textOnly = ['euiTextColor', 'euiTextSubduedColor', 'euiTitleColor'];
export var textColors = [].concat(textOnly, ['euiColorGhost', 'euiColorInk']);
export var allowedColors = [].concat(coreColors, grayColors);
export var textVariants = [].concat(coreTextVariants, _toConsumableArray(textColors));
import { getContrastRatings } from './_contrast_utilities';
export var ColorSectionSass = function ColorSectionSass(_ref) {
  var color = _ref.color,
      minimumContrast = _ref.minimumContrast,
      showTextVariants = _ref.showTextVariants,
      matchPanelColor = _ref.matchPanelColor;
  var palette = useJsonVars();
  var colorsForContrast = showTextVariants ? textVariants : allowedColors;

  function colorIsCore(color) {
    return coreColors.includes(color) || coreTextVariants.includes(color);
  }

  return ___EmotionJSX(EuiPanel, {
    color: "transparent",
    hasBorder: false,
    paddingSize: matchPanelColor ? 'l' : 'none',
    style: {
      background: matchPanelColor ? palette[color] : undefined
    }
  }, ___EmotionJSX(EuiText, {
    size: "xs"
  }, ___EmotionJSX(EuiFlexGrid, {
    columns: 2,
    direction: "column",
    gutterSize: "s"
  }, showTextVariants && colorIsCore(color) && ___EmotionJSX(ColorsContrastItem, {
    foreground: "".concat(color, "Text"),
    background: 'euiPageBackgroundColor',
    minimumContrast: minimumContrast
  }), colorsForContrast.map(function (color2) {
    if (colorIsCore(color) && colorIsCore(color2)) {
      // i.e. don't render if both are core colors
      return;
    }

    return ___EmotionJSX(ColorsContrastItem, {
      foreground: color2,
      background: color,
      key: color2,
      minimumContrast: minimumContrast
    });
  }))));
};
ColorSectionSass.propTypes = {
  color: PropTypes.string.isRequired,
  minimumContrast: PropTypes.oneOfType([PropTypes.string.isRequired, PropTypes.number.isRequired]).isRequired,
  showTextVariants: PropTypes.bool.isRequired,
  matchPanelColor: PropTypes.bool
};

var ColorsContrastItem = ({
  foreground,
  background,
  minimumContrast
}) => {
  const palette = useJsonVars();
  const backgroundColor = palette[background];
  const foregroundColor = palette[foreground];
  const backgroundIsBody = background === 'euiPageBackgroundColor';
  const contrast = chroma.contrast(backgroundColor, foregroundColor);

  if (!contrast || contrast < minimumContrast) {
    return <></>;
  }

  const {
    contrastRating,
    contrastRatingBadge
  } = getContrastRatings(contrast, foreground);
  const contrastIsAcceptableToCopy = contrast >= 3;
  const textToCopy = backgroundIsBody ? `color: $${foreground};` : `background-color: $${background};
color: $${foreground};`;
  const beforeMessage = contrastIsAcceptableToCopy ? <small>
      <code>{`$${foreground} / $${background}`}</code>
      <EuiHorizontalRule margin="xs" />
      <kbd>Click</kbd> to copy SASS configuration
    </small> : <small>
      Cannot copy configuration because the contrast is not acceptable
    </small>;
  return <EuiFlexItem className="eui-textCenter">
      <EuiCopy anchorClassName="eui-displayBlock" title={<span>
            {contrastRatingBadge} Contrast is {contrast.toFixed(1)}
          </span>} beforeMessage={beforeMessage} afterMessage={<small>Copied!</small>} textToCopy={textToCopy}>
        {copy => // @ts-ignore Bad badge types
      <EuiBadge className="guideColorSection__button" iconType={contrastRating} onClick={contrastIsAcceptableToCopy ? copy : undefined} onClickAriaLabel={contrastIsAcceptableToCopy ? 'Click to copy Sass configurations' : undefined} style={{
        backgroundColor: backgroundColor,
        color: foregroundColor
      }}>
            {sanitizeColorName(foreground)}
          </EuiBadge>}
      </EuiCopy>
    </EuiFlexItem>;
};

ColorsContrastItem.propTypes = {
  foreground: PropTypes.string.isRequired,
  background: PropTypes.string.isRequired,
  minimumContrast: PropTypes.oneOfType([PropTypes.string.isRequired, PropTypes.number.isRequired]).isRequired
};

function sanitizeColorName(color) {
  const string = color.split('euiColor').pop(); // Make sure `eui` is removed if it wasnt the full `euiColor` string

  const noEui = string?.split('eui').pop(); // Add space between caplital letters

  return noEui?.replace(/([A-Z])/g, ' $1').trim();
}

try {
  ColorSectionSass.__docgenInfo = {
    tags: {},
    filePath: '/app/src-docs/src/views/theme/color/_contrast_sass.tsx',
    description: '',
    displayName: 'ColorSectionSass',
    methods: [],
    props: {
      color: {
        defaultValue: null,
        description: '',
        name: 'color',
        parent: undefined,
        declarations: [{
          fileName: 'app/src-docs/src/views/theme/color/_contrast_sass.tsx',
          name: 'TypeLiteral'
        }],
        required: true,
        type: {
          name: 'string'
        }
      },
      minimumContrast: {
        defaultValue: null,
        description: '',
        name: 'minimumContrast',
        parent: undefined,
        declarations: [{
          fileName: 'app/src-docs/src/views/theme/color/_contrast_sass.tsx',
          name: 'TypeLiteral'
        }],
        required: true,
        type: {
          name: 'string | number'
        }
      },
      showTextVariants: {
        defaultValue: null,
        description: '',
        name: 'showTextVariants',
        parent: undefined,
        declarations: [{
          fileName: 'app/src-docs/src/views/theme/color/_contrast_sass.tsx',
          name: 'TypeLiteral'
        }],
        required: true,
        type: {
          name: 'boolean'
        }
      },
      matchPanelColor: {
        defaultValue: null,
        description: '',
        name: 'matchPanelColor',
        parent: undefined,
        declarations: [{
          fileName: 'app/src-docs/src/views/theme/color/_contrast_sass.tsx',
          name: 'TypeLiteral'
        }],
        required: false,
        type: {
          name: 'boolean'
        }
      }
    },
    extendedInterfaces: []
  };
} catch (e) {}